import React, { Component } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import { degrees } from "../../portfolio";
import "./EducationComponent.css";
import { Fade } from "react-reveal";

class Education extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <div className="education-main">
        <Header theme={this.props.theme} />
        <main className="education-shell">
          <Fade bottom duration={1200} distance="32px">
            <section className="education-hero">
              <p className="education-eyebrow">Academic background</p>
              <h1 className="education-heading" style={{ color: theme.text }}>
                Education
              </h1>
              <p
                className="education-subheading"
                style={{ color: theme.secondaryText }}
              >
                A combined law and computer science pathway, with exchange study,
                competitive results and a strong mix of technical and legal work.
              </p>
            </section>
          </Fade>

          <section className="education-timeline">
            {degrees.degrees.map((degree, index) => {
              return (
                <Fade bottom duration={1000} distance="28px" key={degree.title}>
                  <article className="education-card">
                    <div className="education-card-marker">
                      <span>{String(index + 1).padStart(2, "0")}</span>
                    </div>
                    <div className="education-card-main">
                      <div className="education-card-header">
                        <div className="education-logo-wrap">
                          {degree.logo_path ? (
                            <img
                              src={require(`../../assests/images/${degree.logo_path}`)}
                              alt={degree.alt_name}
                            />
                          ) : (
                            <span>{degree.title.charAt(0)}</span>
                          )}
                        </div>
                        <div>
                          <h2>{degree.title}</h2>
                          <p>{degree.subtitle}</p>
                        </div>
                        <time>{degree.duration}</time>
                      </div>

                      <div className="education-detail-grid">
                        {degree.descriptions.map((description) => {
                          return (
                            <p className="education-detail" key={description}>
                              {description}
                            </p>
                          );
                        })}
                      </div>

                      {degree.website_link && (
                        <a
                          className="education-card-link"
                          href={degree.website_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Visit institution
                        </a>
                      )}
                    </div>
                  </article>
                </Fade>
              );
            })}
          </section>
        </main>
        <Footer theme={this.props.theme} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Education;
